export enum SortDirection {
  ASCENDING = 'ASC',
  DESCENDING = 'DESC',
}

export enum OrderStatusEnum {
  ADDING_ITEMS = 'AddingItems',
  SUBMITTED_BY_CUSTOMER = 'SubmittedByCustomer',
  APPROVED = 'Approved',
  CANCELLED = 'Cancelled',
  BILLED = 'BILLED',
  WAITING_FOR_CONFIRMATION = 'WaitingForCNF',
  CONFIRMED = 'Confirmed',
}

export enum DividerColorVariant {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum CatalogueView {
  ListWithImagesView = 'ListWithImagesView',
  ThumbnailView = 'ThumbnailView',
  ListView = 'ListView',
}

export enum OrderProductUpdateType {
  PRICE = 'price',
  QUANTITY = 'quantity',
}

export enum OrderProductActionType {
  ADD = 'Add',
  EDIT = 'Edit',
  DELETE = 'Delete',
  REMOVE = 'Remove',
}

export enum PromotionTypes {
  PRODUCT_DISCOUNT = 'product_discount',
  BUYXGETY = 'buy_x_get_y_free',
}

export enum PricingType {
  CUSTOMER = 'customer',
  CFA = 'cfa',
}

export enum InvoiceStatusEnum {
  PENDING = 'P',
  PARTIAL = 'PP',
  PAID = 'PD',
  CANCELLED = 'C',
  DEFAULT = '',
}

export enum IssueStatusEnum {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum InvoiceInteractionStatus {
  SEEN = 'seen',
  ENGAGED = 'engaged',
  SENT = 'sent',
}

export enum PaymentCodes {
  All_Payments = '',
  Pending = 'P',
  PartiallyPaid = 'PP',
  Paid = 'PD',
  Cancelled = 'C',
  OverDue = 'OD',
  UnPaid = 'UD',
}

export enum MessageStatus {
  MESSAGE_DELIVERED = 'MESSAGE_DELIVERED',
  MESSAGE_SEEN = 'MESSAGE_SEEN',
  MESSAGE_SENT = 'MESSAGE_SENT',
  ENGAGED = 'engaged',
}

export enum PaymentStatusEnum {
  SENT = 'SNT',
  CONFIRMED = 'CNF',
  PAID = 'P',
  FAILED = 'F',
  CANCELLED = 'N',
  DEFAULT = '',
}

export enum PaymentModeType {
  CHQ = 'Cheque',
  DD = 'Demand Draft',
  BNTR = 'Bank Transfer',
  CASH = 'Cash',
  UPI = 'UPI',
  CREDIT_CARD = 'Credit/Debit Card',
}

export enum PaymentFieldKeys {
  PAYMENT_MODE = 'paymentMode',
  PAYMENT_DATE = 'paymentDate',
  AMOUNT_PAID = 'amountPaid',
  PAYMENT_TIME = 'paymentTime',
  PAYMENT_REFERENCE_CODE = 'paymentRefCode',
  BANK_NAME = 'bankName',
  BANK_ACCOUNT_NUMBER = 'bankAccountNumber',
  NARRATION = 'narration',
  UPI_ID = 'upiId',
  INSTRUMENT_NUMBER = 'instrumentNumber',
  PAYMENT_TYPE = 'paymentType',
  BANK_REFERENCE = 'bankReference',
  CARD_NUMBER = 'cardNumber',
  CARD_TYPE = 'cardType',
  PAYMENT_PROVIDER = 'paymentProvider',
}

export type DiscountType = 'percent' | 'direct';
export type OrderDiscountLevel = 'item' | 'order';
export type SelectionModeType = 'single' | 'multiple' | 'null';

export enum MessageType {
  TEXT = 'text',
  MEDIA = 'media',
  FORWARD = 'forward',
  ISSUE = 'issue',
  ORDER = 'order',
  PRICE_LIST = 'priceList',
  INVOICE_LIST = 'invoiceList',
  SCHEME_LIST = 'schemeList',
  PAYMENT = 'payment',
  INVOICE = 'invoice',
  REQUIREMENT = 'requirement',
  CUSTOMER_NOT_FOUND = 'customerNotFound',
  WHATSAPP_TEMPLATE = 'waCustomTemplate',
  ZOEY_ORDER_REPORT = 'orderReport',
  ZOEY_INVOICE_REPORT = 'invoiceReport',
  LEDGER = 'ledger',
  CAMPAIGN = 'campaign',
  CHANNEL_UPDATE = 'CU',
  INTERACTIVE = 'interactive',
  DISPATCH = 'dispatch',
  TYPEBOT = 'typeBot',
  DISPACH_NOTE = 'dispatchList',
  ORDER_RECEIPT = 'orderReceipt',
  PAYMENT_RECEIPT = 'paymentReceipt',
  SURVEY_FORM = 'survey-form',
}

export enum CustomerGroupsEnum {
  NEW_LEAD = 'New Lead',
  ACTIVATED = 'Activated',
  COLD = 'Cold',
  IRRELEVANT = 'Irrelevant',
  WARM = 'Warm',
  ACTIVE = 'Active',
  DORMANT = 'Dormant',
  INACTIVE = 'To Be Inactive',
}
